import { EntityStore, type Merge } from './entityStore';
import type { DeviceLive } from './types';

/** Nested maps (metrics, reported) merge per key, so partial deltas never drop other values. */
export const mergeDeviceLive: Merge<DeviceLive> = (base, delta) => ({
  ...base,
  ...delta,
  ...(delta.metrics ? { metrics: { ...base?.metrics, ...delta.metrics } } : {}),
  ...(delta.reported ? { reported: { ...base?.reported, ...delta.reported } } : {}),
});

/** Application-wide realtime stores (one instance each; written only by the event router). */
export const deviceLive = new EntityStore<DeviceLive>(undefined, mergeDeviceLive);
